import {useCallback, useEffect, useState} from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import {hideScroll} from 'src/theme/css';
import {usePathname} from 'src/routes/hooks';

import {useResponsive} from 'src/hooks/use-responsive';
import {useMockedUser} from 'src/hooks/use-mocked-user';

import {NavSectionVertical} from 'src/minimal-components/nav-section';
import CheckIcon from '@mui/icons-material/Check';
import {CircularProgress, IconButton, ListItemIcon} from '@mui/material';
import NavToggleButton from 'src/layouts/common/nav-toggle-button';
import {NAV} from 'src/layouts/config-layout';
import {TreeView, TreeItem} from '@mui/x-tree-view';
import {ChevronDown, ChevronRight, EditIcon} from 'lucide-react';
import React from 'react';
import {
  List,
  ListItem,
  ListItemText,
  Collapse,
  Drawer,
  Typography
} from '@mui/material';
import {ExpandLess, ExpandMore} from '@mui/icons-material';
import {Description as DescriptionIcon} from '@mui/icons-material';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import LinkIcon from '@mui/icons-material/Link';
import AssignmentIcon from '@mui/icons-material/Assignment';
import QuizIcon from '@mui/icons-material/Quiz';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import {fileFormat, fileThumb} from 'src/minimal-components/file-thumbnail';
import {useModulePreviewContext} from '@context/ModulePreviewContextProvider';
import {set} from 'lodash';
import EncryptUtils from 'src/utils/EncryptUtils';
import {getLMSResultsData} from '@shared/services/service-handlers/PrivateService';
import {
  BASE_RECORD_ID,
  BASE_UNIQUE_ID,
  LMS_IS_ADMIN,
  LMS_MODULE_ID,
  LMS_TYPE
} from 'src/routes/BaseRoute';
import {useAppContext} from '@context/AppContext';
import {useLocation} from 'react-router-dom';
import LockedDialog from '../LockedDialog';
import UnLockedDialog from '../UnLockDialog';
import Logo from 'src/minimal-components/logo/lmsLogo';
import {environment} from '@shared/config/environment';

// Example usage:

interface FileNode {
  id: string;
  name: string;
  type: 'folder' | 'file';
  fileType?: 'presentation' | 'video' | 'pdf';
  children?: FileNode[];
  content?: string[];
  duration?: string;
}

type ModulesMenuListComponentProps = {
  navData: any;
  openNav?: any;
  isOpenNav: boolean;
  onCloseNav: VoidFunction;
  isLoading?: boolean;
  module?: string;
  menuItem?: any;
  renderCountBadge?: (countItem: any) => JSX.Element;
  menuListData?: any;
  filtersData?: any;
  setExternalUrl?: any;
  setVisitDetails?: any;
  applicationName: string;
  uiFieldsPreview: any;
  onFileChange?(value: any): void;
};
interface LockedItem {
  type: 'file' | 'link' | 'content' | 'assignment' | 'onlinetest' | 'module';
  item_name: string;
  id: string;
}
interface ModuleData {
  id: string;
  name: string;
  expanded: boolean;
  description?: string;
  duration?: string;
  type: string;
  sequence: number;
  module_lock_type_id?: number;
  locked_until_date?: string;
  Module_Completed?: boolean;
  IsUnlocked?: boolean;
  is_completed?: boolean;
  locked_linked_items?: {
    id: string;
    item_name: string;
    entity_completion_sub_type_id: number;
    module_link_id: number;
    module_id: number;
    type: 'file' | 'link' | 'content' | 'assignment' | 'onlinetest' | 'module';
  }[];
  files?: {
    id: string;
    name: string;
    ParentName: string;
    blob_file_extension?: string;
    fileexpanded: boolean;
    time?: string;
    score?: string;
    lock_type_id: number;
    locked_until_date?: string;
    type: string;
    module_id: number;
    sequence: number;
    ChildItems_Completed?: boolean;
    IsUnlocked?: boolean;
    is_completed?: boolean;
    additionalFiles?: {id: string; name: string}[];
    locked_linked_items?: {
      id: string;
      item_name: string;
      entity_completion_sub_type_id: number;
      module_link_id: number;
      module_id: number;
      type:
        | 'file'
        | 'link'
        | 'content'
        | 'assignment'
        | 'onlinetest'
        | 'module';
    }[];
  }[];
}
export default function NavPreviewVertical(
  props: ModulesMenuListComponentProps
) {
  const {user} = useMockedUser();
  const pathname = usePathname();
  const lgUp = useResponsive('up', 'lg');
  const {
    navData,
    isOpenNav,
    onCloseNav,
    isLoading,
    module,
    menuItem,
    renderCountBadge,
    menuListData,
    filtersData,
    setExternalUrl,
    setVisitDetails,
    applicationName,
    onFileChange,
    uiFieldsPreview
  } = props;
  const location = useLocation();
  let {uiFieldsvals} = location.state || {};
  const uniqueId = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_RECORD_ID
  );
  const fileId = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_UNIQUE_ID
  );
  const moduleId = EncryptUtils.getDecryptedData(
    location?.search,
    LMS_MODULE_ID
  );
  const lmstype = EncryptUtils.getDecryptedData(location?.search, LMS_TYPE);
  const lmsisAdmin = EncryptUtils.getDecryptedData(
    location?.search,
    LMS_IS_ADMIN
  );
  const {selectedPreviewFile, setSelectedPreviewFile} =
    useModulePreviewContext();
  const {ModulePreviewData, SetModulePreviewData} = useModulePreviewContext();
  const [moduleData, setModuleDate] = useState<ModuleData[]>([]);
  const {currentSlide, setCurrentSlide} = useModulePreviewContext();
  const {isFullscreen, setIsFullscreen} = useModulePreviewContext();
  const [isLockItemsOpen, setLockItemsOpen] = useState(false);
  const [lockitems, setLockItems] = useState<{
    lockData?: LockedItem[];
    lockDate?: string;
    type?: string;
    chapterTitle: string;
  }>({lockData: [], chapterTitle: ''});
  const [isunLockItemsOpen, setunLockItemsOpen] = useState(false);
  const [unlockitems, setunLockItems] = useState<{
    lockData?: LockedItem[];
    lockDate?: string;
    chapterTitle: string;
  }>({lockData: [], chapterTitle: ''});
  const [open, setOpen] = useState<Record<string, boolean>>({
    Introduction: false,
    'Common concepts': false,
    'Data Grid': false,
    'Date and Time Pickers': true
  });

  useEffect(() => {
    if (isOpenNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);
  const handleModuleToggle = (moduleId: string) => {
    SetModulePreviewData((prevState: any[]) =>
      prevState.map(module =>
        module.id === moduleId
          ? {...module, expanded: !module.expanded} // Toggle expanded
          : module
      )
    );
  };
  const onCourseComplete = async (
    moduleId: string,
    fileId: string,
    previewData: boolean,
    type: string
  ) => {
    if (uiFieldsvals || uiFieldsPreview) {
      if (uiFieldsvals === undefined) {
        uiFieldsvals = uiFieldsPreview;
      }
      const {sql_data} = uiFieldsvals['module_sql'];
      const datavalue = {
        course_overview_id: uniqueId,
        file_id: fileId,
        module_id: moduleId,
        name: type,
        coursecomplete: previewData
      };
      const data: any = {
        sql_data: sql_data,
        data: datavalue,
        operation: 'UPDATE'
      };
      const encryptRequestData = EncryptUtils.encryptedData(data);
      const result = await getLMSResultsData(applicationName, 'LMS', {
        tk: encryptRequestData
      });
      const processModulesData = (data: ModuleData[]) => {
        return data.map(module => ({
          ...module,
          files:
            module.files?.map(file => ({
              ...file,
              locked_linked_items:
                typeof file.locked_linked_items === 'string'
                  ? JSON.parse(file.locked_linked_items) // 🛠️ Parse if string
                  : file.locked_linked_items || [], // Keep array or default to empty
              additionalFiles:
                typeof file.additionalFiles === 'string'
                  ? JSON.parse(file.additionalFiles) // 🛠️ Parse if string
                  : file.additionalFiles || [] // Keep array or default to empty
            })) || []
        }));
      };
      const syncExpandedStates = (
        transformed: ModuleData[],
        existing: ModuleData[]
      ) => {
        return transformed.map(module => {
          const matchingModule = existing.find(e => e.id === module.id);

          if (!matchingModule) return module;

          // Sync the `expanded` flag
          const updatedModule = {
            ...module,
            expanded: matchingModule.expanded || false,
            files:
              module?.files &&
              module?.files.map(file => {
                const matchingFile =
                  matchingModule?.files &&
                  matchingModule.files.find(f => f.id === file.id && f.type===file.type);
                return {
                  ...file,
                  fileexpanded: matchingFile?.fileexpanded || false
                };
              })
          };

          return updatedModule;
        });
      };

      // Handling API result
      if (result.data) {
        const transformData = await processModulesData(result.data);
        const updatedTransformed = syncExpandedStates(
          transformData,
          ModulePreviewData
        );
        await SetModulePreviewData(updatedTransformed);
      }
    }
  };
  const handleCompleted = (
    fileId: string,
    moduleId: string,
    types: string,
    previewData?: boolean
  ) => {
    SetModulePreviewData((prevState: ModuleData[]) =>
      prevState.map(module => {
        const updatedFiles =
          module.files?.map(file => ({
            ...file,
            ChildItems_Completed:
              file.id === fileId && module.id === moduleId
                ? !previewData // Toggle only the specific file
                : file?.ChildItems_Completed
                  ? file?.ChildItems_Completed
                  : false
          })) || [];

        // Check if all ChildItems_Completed are true
        const allFilesCompleted =
          updatedFiles.length > 0 &&
          updatedFiles.every(file => file.ChildItems_Completed);

        return {
          ...module,
          files: updatedFiles,
          Module_Completed: allFilesCompleted // Update module completion status
        };
      })
    );
    onCourseComplete(moduleId, fileId, !previewData, types);
  };
  const getNodeIcon = (type: string) => {
    switch (type) {
      case 'file':
        return <InsertDriveFileIcon />;
      case 'content':
        return <DescriptionIcon />;
      case 'link':
        return <LinkIcon />;
      case 'assignment':
        return <AssignmentIcon />;
      case 'onlinetest':
        return <QuizIcon />;
      default:
        return null;
    }
  };
  const handleFileToggle = (moduleId: string, fileId: string, type: string) => {
    SetModulePreviewData((prevState: any[]) =>
      prevState.map(module => ({
        ...module,
        files: module.files?.map(
          (file: {id: string; fileexpanded: any; type: string}) => ({
            ...file,
            fileexpanded:
              module.id === moduleId && file.id === fileId && file.type === type
                ? true // Toggle the current file
                : false // Collapse all other files
          })
        )
      }))
    );
  };

  const handleNodeSelect = (event: any, nodeId: string, type: string) => {
    const findNode = (nodes: any): any | null => {
      for (const node of nodes) {
        if (node.id === nodeId && node.type === type) {
          return node;
        }
        if (node.files) {
          const found = findNode(node.files);
          if (found) {
            return found;
          }
        }
      }
      return null;
    };

    const node = findNode(ModulePreviewData);
    //console.log('navv', node);
    if (
      node?.type === 'file' ||
      node?.type === 'link' ||
      node?.type === 'content' ||
      node?.type === 'assignment' ||
      node?.type === 'onlinetest'
    ) {
      setSelectedPreviewFile(node);
      // onFileChange && onFileChange(node);
      setCurrentSlide(0);
    }
  };

  const handleKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isFullscreen) {
        setIsFullscreen(false);
      } else if (e.key === 'ArrowUp') {
        setCurrentSlide((prev: number) => Math.max(0, prev - 1));
      } else if (e.key === 'ArrowDown') {
        setCurrentSlide((prev: number) =>
          Math.min(prev + 1, (selectedPreviewFile?.content?.length || 1) - 1)
        );
      }
    },
    [isFullscreen, selectedPreviewFile]
  );

  React.useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);

  const renderContent = (
    <Stack
      sx={{
        flex: 1,
        backgroundColor: theme => theme.palette.primary.darker,
        overflowY: 'auto',
        overflowX: 'hidden',
        '::-webkit-scrollbar': {
          width: '10px'
        },
        '::-webkit-scrollbar-track': {
          backgroundColor: 'transparent'
        },
        '::-webkit-scrollbar-thumb': {
          backgroundColor: theme => theme.palette.grey[500],
          borderRadius: '999px'
        }
      }}>
      {/* <Box
        component="div"
        sx={{
          width: '40px',
          height: '40px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}></Box> */}

      {isLoading ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%'
          }}>
          <CircularProgress />
        </Box>
      ) : (
        <List>
          {/* Main Sections */}
          {ModulePreviewData &&
            ModulePreviewData.sort((a, b) => a.sequence - b.sequence).map(
              (item, index) => (
                <React.Fragment key={`${item.id}_${index}_module`}>
                  <ListItem
                    disabled={
                      lmsisAdmin === 'False'
                        ? item?.module_lock_type_id === 3
                          ? item?.files?.length === 0
                            ? true
                            : item?.module_lock_type_id === 3 &&
                                item?.is_completed
                              ? false
                              : item?.module_lock_type_id === 3 &&
                                  item?.locked_linked_items &&
                                  item?.locked_linked_items?.length > 0 &&
                                  item?.is_completed !== false
                                ? true
                                : false
                          : item?.module_lock_type_id === 2 && item?.IsUnlocked
                            ? false
                            : false
                        : false
                    }
                    onClick={() => {
                      if (
                        lmsisAdmin === 'False' &&
                        item?.module_lock_type_id === 3
                          ? item?.files?.length === 0
                            ? true
                            : item?.module_lock_type_id === 3 &&
                                item?.is_completed
                              ? false
                              : item?.module_lock_type_id === 3 &&
                                  item?.locked_linked_items &&
                                  item?.locked_linked_items?.length > 0 &&
                                  item?.is_completed !== false
                                ? true
                                : false
                          : item?.module_lock_type_id === 2 && item?.IsUnlocked
                            ? false
                            : false
                      ) {
                        return;
                      } else {
                        return handleModuleToggle(item.id);
                      }
                    }}>
                    <ListItemText
                      primary={
                        <Typography
                          sx={{
                            cursor: 'pointer',
                            fontWeight: 'bold',
                            color:
                              !environment?.IS_LMS_ENABLED_FOR_EXTERNAL_SITE_AS_EMBEDDED
                                ? item.expanded
                                  ? 'primary.main'
                                  : 'white'
                                : item.expanded
                                  ? 'primary.main'
                                  : 'black'
                          }}>
                          {item.name}
                        </Typography>
                      }
                    />
                    {item.module_lock_type_id !== 1 &&
                    lmstype === 'view' &&
                    lmsisAdmin === 'False' ? (
                      (item?.IsUnlocked && item.module_lock_type_id === 2) ||
                      (item?.is_completed && item.module_lock_type_id === 3) ? (
                        <IconButton
                          size="small"
                          onClick={() => {
                            setunLockItemsOpen(true);
                            if (item.locked_linked_items) {
                              setunLockItems({
                                lockData: item.locked_linked_items,
                                chapterTitle: item.name
                              });
                            }
                            if (item.locked_until_date) {
                              setunLockItems({
                                lockDate: item.locked_until_date,
                                chapterTitle: item.name
                              });
                            }
                          }}>
                          <LockOpenIcon />
                        </IconButton>
                      ) : (
                        <IconButton
                          size="small"
                          onClick={() => {
                            setLockItemsOpen(true);
                            if (item.locked_linked_items) {
                              setLockItems({
                                lockData: item.locked_linked_items,
                                chapterTitle: item.name,
                                type: item.type
                              });
                              setSelectedPreviewFile({
                                lockData: item.locked_linked_items,
                                ParentName: item.name,
                                type: item.type
                              });
                            }
                            if (item.locked_until_date) {
                              setLockItems({
                                lockDate: item.locked_until_date,
                                chapterTitle: item.name,
                                type: item.type
                              });
                              setSelectedPreviewFile({
                                lockDate: item.locked_until_date,
                                ParentName: item.name,
                                type: item.type
                              });
                            }
                            handleFileToggle(item.id, item.id, item.type);
                          }}>
                          <LockIcon />
                        </IconButton>
                      )
                    ) : (
                      item.module_lock_type_id !== 1 && (
                        <IconButton
                          size="small"
                          onClick={event => {
                            setLockItemsOpen(true);
                            if (item.locked_linked_items) {
                              setLockItems({
                                lockData: item.locked_linked_items,
                                chapterTitle: item.name
                              });
                            }
                            if (item.locked_until_date) {
                              setLockItems({
                                lockDate: item.locked_until_date,
                                chapterTitle: item.name
                              });
                            }
                          }}>
                          <LockIcon />
                        </IconButton>
                      )
                    )}
                    {lmstype === 'view' && lmsisAdmin === 'False' && (
                      <IconButton
                        sx={{
                          width: 15,
                          height: 15,
                          borderRadius: '50%',
                          marginRight: 1,
                          backgroundColor:
                            item.Module_Completed ||
                            (item.files && item.files.length === 0)
                              ? 'green'
                              : '#b3beb3',
                          border:
                            item.Module_Completed ||
                            (item.files && item.files.length === 0)
                              ? 'none'
                              : '2px solid gray',
                          color:
                            item.Module_Completed ||
                            (item.files && item.files.length === 0)
                              ? 'white'
                              : 'gray',
                          transition: 'all 0.3s',
                          '&:hover': {
                            backgroundColor:
                              item.Module_Completed ||
                              (item.files && item.files.length === 0)
                                ? 'darkgreen'
                                : 'rgba(0, 0, 0, 0.1)'
                          }
                        }}></IconButton>
                    )}
                    {item?.files &&
                      item?.files?.length > 0 &&
                      (item.expanded ? (
                        <ExpandLess
                          sx={{
                            cursor: 'pointer',
                            color:
                              !environment?.IS_LMS_ENABLED_FOR_EXTERNAL_SITE_AS_EMBEDDED
                                ? item.expanded
                                  ? 'primary.main'
                                  : 'white'
                                : item.expanded
                                  ? 'primary.main'
                                  : 'black'
                          }}
                        />
                      ) : (
                        <ExpandMore
                          sx={{
                            cursor: 'pointer',
                            color:
                              !environment?.IS_LMS_ENABLED_FOR_EXTERNAL_SITE_AS_EMBEDDED
                                ? item.expanded
                                  ? 'primary.main'
                                  : 'white'
                                : item.expanded
                                  ? 'primary.main'
                                  : 'black'
                          }}
                        />
                      ))}
                  </ListItem>

                  {/* Sub-items */}
                  {item.files && item.files.length > 0 && (
                    <Collapse in={item.expanded} timeout="auto" unmountOnExit>
                      <List component="div" disablePadding>
                        {item.files
                          .sort((a, b) => a.sequence - b.sequence)
                          .map((items, idx) => (
                            <ListItem
                              key={`${items.type}-${String(items.id)}`}
                              onClick={event => {
                                handleFileToggle(item.id, items.id, items.type);
                                handleNodeSelect(event, items.id, items.type);
                              }}
                              sx={{
                                borderRadius: 2,
                                bgcolor: '#3dd60600',
                                boxShadow:
                                  !environment?.IS_LMS_ENABLED_FOR_EXTERNAL_SITE_AS_EMBEDDED
                                    ? items.fileexpanded
                                      ? '0px 2px 1px -1px #74ff30, 0px 1px 19px -4px rgb(162 171 145), 19px 40px 22px 29px rgba(0, 1, 1, 0)'
                                      : 1
                                    : items.fileexpanded
                                      ? '0 6px 20px #82d1f580'
                                      : 1,
                                marginBottom:
                                  environment?.IS_LMS_ENABLED_FOR_EXTERNAL_SITE_AS_EMBEDDED
                                    ? 2
                                    : 0,
                                background:
                                  environment?.IS_LMS_ENABLED_FOR_EXTERNAL_SITE_AS_EMBEDDED
                                    ? items.fileexpanded
                                      ? 'transparent linear-gradient(116deg, #015aa7 0%, #00aae7 100%) 0% 0% no-repeat padding-box'
                                      : 'transparent'
                                    : ''
                              }}>
                              {/* Left Icon */}
                              {items?.type === 'file' &&
                              items?.blob_file_extension ? (
                                <Box
                                  component="img"
                                  src={
                                    items?.blob_file_extension === 'dcm'
                                      ? '/assets/icons/files/dcm.png'
                                      : fileThumb(items?.blob_file_extension)
                                  }
                                  sx={{
                                    width: 24,
                                    height: 24,
                                    flexShrink: 0,
                                    mr: 2
                                  }}
                                />
                              ) : (
                                <ListItemIcon
                                  sx={{
                                    color:
                                      !environment?.IS_LMS_ENABLED_FOR_EXTERNAL_SITE_AS_EMBEDDED
                                        ? items.fileexpanded
                                          ? '#6bddcf'
                                          : 'white'
                                        : items.fileexpanded
                                          ? 'white'
                                          : 'black'
                                  }}>
                                  {getNodeIcon(items?.type)}
                                </ListItemIcon>
                              )}

                              {/* Content */}
                              <ListItemText
                                sx={{rowGap: '5px', display: 'grid'}}
                                primary={
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      alignItems: 'center'
                                    }}>
                                    <Typography
                                      sx={{
                                        fontWeight: 'bold',
                                        fontSize: '1rem',
                                        marginRight: 'auto',
                                        color:
                                          !environment?.IS_LMS_ENABLED_FOR_EXTERNAL_SITE_AS_EMBEDDED
                                            ? items.fileexpanded
                                              ? '#6bddcf'
                                              : 'aliceblue'
                                            : items.fileexpanded
                                              ? 'white'
                                              : 'black'
                                      }}>
                                      {items.name}
                                    </Typography>
                                  </Box>
                                }
                                secondary={
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      columnGap: 2
                                    }}>
                                    <Typography
                                      sx={{
                                        fontSize: '0.8rem',
                                        color: items.fileexpanded
                                          ? !environment?.IS_LMS_ENABLED_FOR_EXTERNAL_SITE_AS_EMBEDDED
                                            ? 'text.secondary'
                                            : 'white'
                                          : 'black'
                                      }}>
                                      {items.time}
                                    </Typography>
                                    <Typography
                                      sx={{
                                        fontSize: '0.8rem',
                                        color: items.fileexpanded
                                          ? !environment?.IS_LMS_ENABLED_FOR_EXTERNAL_SITE_AS_EMBEDDED
                                            ? 'text.secondary'
                                            : 'white'
                                          : 'black'
                                      }}>
                                      {items?.type !== 'file'
                                        ? items.type
                                        : items?.blob_file_extension}
                                    </Typography>
                                  </Box>
                                }
                              />
                              {lmstype === 'view' &&
                              lmsisAdmin === 'False' &&
                              items.lock_type_id !== 1 ? (
                                (items?.IsUnlocked &&
                                  items.lock_type_id === 2) ||
                                (items?.is_completed &&
                                  items.lock_type_id === 3) ? (
                                  <IconButton
                                    size="small"
                                    onClick={event => {
                                      // setunLockItemsOpen(true);
                                      if (items.locked_linked_items) {
                                        setunLockItems({
                                          lockData: items.locked_linked_items,
                                          chapterTitle: items.name
                                        });
                                      }
                                      if (items.locked_until_date) {
                                        setunLockItems({
                                          lockDate: items.locked_until_date,
                                          chapterTitle: items.name
                                        });
                                      }
                                    }}>
                                    <LockOpenIcon />
                                  </IconButton>
                                ) : (
                                  <IconButton
                                    size="small"
                                    onClick={event => {
                                      // setLockItemsOpen(true);
                                      if (items.locked_linked_items) {
                                        setLockItems({
                                          lockData: items.locked_linked_items,
                                          chapterTitle: items.name
                                        });
                                      }
                                      if (items.locked_until_date) {
                                        setLockItems({
                                          lockDate: items.locked_until_date,
                                          chapterTitle: items.name
                                        });
                                      }
                                    }}>
                                    <LockIcon />
                                  </IconButton>
                                )
                              ) : (
                                items.lock_type_id !== 1 && (
                                  <IconButton
                                    size="small"
                                    onClick={event => {
                                      // setLockItemsOpen(true);
                                      if (items.locked_linked_items) {
                                        setLockItems({
                                          lockData: items.locked_linked_items,
                                          chapterTitle: items.name
                                        });
                                      }
                                      if (items.locked_until_date) {
                                        setLockItems({
                                          lockDate: items.locked_until_date,
                                          chapterTitle: items.name
                                        });
                                      }
                                    }}>
                                    <LockIcon />
                                  </IconButton>
                                )
                              )}
                              {/* Edit Icon */}
                              <ListItemIcon
                                sx={{
                                  color: items.fileexpanded
                                    ? '#6bddcf'
                                    : 'white'
                                }}>
                                {lmstype === 'view' &&
                                  lmsisAdmin === 'False' && (
                                    <IconButton
                                      onClick={() =>
                                        handleCompleted(
                                          items.id,
                                          item.id,
                                          items.type,
                                          items?.ChildItems_Completed
                                        )
                                      }
                                      disabled={
                                        items.type === 'onlinetest' ||
                                        (items.lock_type_id === 2 &&
                                          !items?.IsUnlocked) ||
                                        (items.lock_type_id === 3 &&
                                          !items?.is_completed)
                                          ? true
                                          : !items.fileexpanded?true: items?.ChildItems_Completed
                                      }
                                      sx={{
                                        width: 20,
                                        height: 20,
                                        borderRadius: '50%',
                                        marginRight: 1,
                                        backgroundColor:
                                          items.ChildItems_Completed
                                            ? 'green'
                                            : '#b3beb3',
                                        border: items.ChildItems_Completed
                                          ? 'none'
                                          : '2px solid gray',
                                        color: items.ChildItems_Completed
                                          ? 'white'
                                          : 'gray',
                                        transition: 'all 0.3s',
                                        '&:hover': {
                                          backgroundColor:
                                            items.ChildItems_Completed
                                              ? 'darkgreen'
                                              : 'rgba(0, 0, 0, 0.1)'
                                        },
                                        '&.Mui-disabled': {
                                          backgroundColor:
                                            items.ChildItems_Completed
                                              ? 'green'
                                              : 'transparent',
                                          color: items.ChildItems_Completed
                                            ? 'white'
                                            : 'rgba(145, 158, 171, 0.8)'
                                        }
                                      }}>
                                      {<CheckIcon />}
                                    </IconButton>
                                  )}
                              </ListItemIcon>
                            </ListItem>
                          ))}
                      </List>
                    </Collapse>
                  )}
                </React.Fragment>
              )
            )}
        </List>
      )}
      {isLockItemsOpen && (
        <LockedDialog
          open={isLockItemsOpen}
          onClose={() => {
            setLockItemsOpen(false);
            setLockItems({lockData: [], chapterTitle: ''});
          }}
          items={lockitems}
        />
      )}
      {/* {isunLockItemsOpen && (
        <UnLockedDialog
          open={isunLockItemsOpen}
          onClose={() => {
            setunLockItemsOpen(false);
            setunLockItems({lockData: [], chapterTitle: ''});
          }}
          items={unlockitems}
        />
      )} */}
    </Stack>
  );

  return (
    <Box
      sx={{
        flexShrink: {lg: 0},
        width: {lg: NAV.W_VERTICAL}
      }}>
      {/* <NavToggleButton /> */}

      {lgUp ? (
        <Stack
          sx={{
            pb: 2,
            height: 1,
            position: 'fixed',
            width: NAV.W_VERTICAL,
            backgroundColor: theme => theme.palette.primary.darker,
            borderRight: theme => `dashed 1px ${theme.palette.divider}`,
            ...hideScroll.x
          }}>
          <Box sx={{display: 'flex'}}>
            <Logo
              applicationName={applicationName}
              sx={{mt: 1, mb: 1, ml: 1, flex: 1}}
            />
          </Box>
          {renderContent}
        </Stack>
      ) : (
        <Drawer
          open={isOpenNav}
          onClose={onCloseNav}
          PaperProps={{
            sx: {
              width: NAV.W_VERTICAL
            }
          }}>
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}

